import { styled } from "theme/default/styled";
import { setFlexDFAIC } from "theme/setter/setFlexValues/setFlexDFAIC";

export const SDetailsCell = styled.button`
  padding-left: 8px;

  ${setFlexDFAIC};
`;
